import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const tantrum3YearOld: BlogMetaData = {
  title: '魔の三歳児（魔の三歳）・3歳の癇癪がひどい…原因と対処法5選｜モンテッソーリ流',
  description:
    '魔の三歳児（魔の三歳）の癇癪がひどいと感じていませんか？魔の三歳とは何かを整理し、癇癪が起きる原因（自我の芽生え・秩序の敏感期・言語発達のギャップ）を理解してモンテッソーリ教育に基づく対処法5選とNGな対応をわかりやすく解説します。',
  thumbnailUrl: '/img/blog-tantrum-3-year-old.png',
  filePath: buildBlogFilePath('tantrum-3-year-old'),
  category: BLOG_CATEGORY.PARENTING,
};
